<script lang="ts" setup>
  import type { Component } from 'vue'

  withDefaults(
    defineProps<{
      icon: Component
      title: string
      description?: string
      tone?: 'neutral' | 'error'
    }>(),
    {
      description: '',
      tone: 'neutral'
    }
  )
</script>

<template>
  <div
    :role="tone === 'error' ? 'alert' : undefined"
    class="m-4 flex flex-1 flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-silver p-10 text-center"
  >
    <component :is="icon" :class="tone === 'error' ? 'text-destructive' : 'text-muted-foreground'" class="size-8" />
    <p class="text-sm font-semibold text-primary">{{ title }}</p>
    <p v-if="description" class="max-w-md text-xs text-muted-foreground">{{ description }}</p>
    <div class="flex gap-2">
      <slot name="actions" />
    </div>
  </div>
</template>
